module.exports = __webpack_public_path__ + "static/media/icon1.0124ce8c.svg";